import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { api } from '../lib/api';
import { useI18n } from '../context/I18nContext';
import PostCard from '../components/PostCard';
import BottomNav from '../components/BottomNav';
import LanguageToggle from '../components/LanguageToggle';
import { toast } from 'sonner';

export default function PostPage() {
  const { publicId } = useParams();
  const nav = useNavigate();
  const { t } = useI18n();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/posts/${publicId}`);
        setPost(data);
      } catch (err) {
        toast.error(err?.response?.data?.detail || t('common.error'));
      } finally { setLoading(false); }
    })();
  }, [publicId, t]);

  return (
    <div className="min-h-screen bg-aura-bg pb-28 relative">
      <header className="flex items-center justify-between px-5 pt-6">
        <button onClick={() => nav(-1)} className="text-aura-textDim hover:text-white flex items-center gap-1" data-testid="btn-back">
          <ChevronLeft size={20} />
        </button>
        <LanguageToggle />
      </header>
      <main className="mx-auto max-w-md px-4 pt-4">
        {loading ? (
          <div className="text-center py-20 text-aura-textDim animate-aura-pulse text-4xl">⚡</div>
        ) : !post ? (
          <div className="text-center py-20 text-aura-textDim">404</div>
        ) : (
          <PostCard post={post} onDeleted={() => nav('/home', { replace: true })} />
        )}
      </main>
      <BottomNav />
    </div>
  );
}
